import React, { useEffect } from 'react';

interface SuspenseLoadingStatusProps {
    onStart: () => void;
    onEnd: () => void;
}

export const SuspenseLoadingStatus: React.FC<SuspenseLoadingStatusProps> = ({ onStart, onEnd }) => {
    useEffect(() => {
        onStart();
        return () => {
            onEnd();
        };
    }, []);

    return null;
};
